module.exports = __webpack_public_path__ + "static/media/ecoline.f605a309.pdf";